module.exports = "https://cdn.realtymogul.com/static/media/img_hero_GetFin.a5d70ef2.jpg";